"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPercentFieldValueToString = void 0;
const number_1 = require("../utils/number");
const detailed_decimal_1 = require("./detailed-decimal");
const convertPercentFieldValueToString = ({ value, locale, params, }) => {
    var _a, _b, _c;
    if (value === null || value === undefined) {
        return "";
    }
    const asString = (0, detailed_decimal_1.convertNumberToFormatedString)({
        value,
        precision: (_a = params.precision) !== null && _a !== void 0 ? _a : 0,
        decimalSeparator: (_b = params.decimal_separator) !== null && _b !== void 0 ? _b : (0, number_1.getDecimalSeparator)(locale),
        thousandSeparator: params.separator
            ? (_c = params.thousand_separator) !== null && _c !== void 0 ? _c : (0, number_1.getGroupSeparator)(locale)
            : "",
    });
    return `${asString}%`.trim();
};
exports.convertPercentFieldValueToString = convertPercentFieldValueToString;
